import React from 'react'
import { StaticQuery, graphql } from 'gatsby'

interface OwnProps {
  description?: string
  lang?: string
  meta?: []
  ogDescription?: string
  ogImage?: string
  ogTitle?: string
  title: string
}

type SEOProps = OwnProps

const SEO: React.FC<SEOProps> = ({
  description,
  ogDescription,
  ogImage,
  ogTitle,
  title
}): React.ReactElement => (
  <StaticQuery
    query={`${SeoQuery}`}
    render={(data) => {
      const baseImageUrl = ogImage?.split("?")[0];
      const metaTitle = title
        ? `${title} | ${data.site.siteMetadata.title}`
        : data.site.siteMetadata.title;
      const metaDescription = description || data.site.siteMetadata.description;

      return (
        <>
          <html lang="en-US" />
          <title>{metaTitle}</title>
          {metaDescription && <meta name="description" content={metaDescription} />}
          {ogDescription || metaDescription && <meta name="og:description" content={ogDescription || metaDescription} />}
          {baseImageUrl && <meta name="og:image" content={baseImageUrl} />}
          {ogTitle || metaTitle && <meta name="og:title" content={ogTitle || metaTitle} />}
          <meta name="og:type" content="page" />
        </>     
      )
    }}
  />
)

const SeoQuery = graphql`
query {
  site {
    siteMetadata {
      author
      description
      siteURL
      title
    }
  }
}
`

export default SEO
